<template>
  <FormProduct :id="id" />
</template>

<script>
import FormProduct from '@/components/Form/Product'
export default {
  props: {
    id: [String, Number],
  },
  components: {
    FormProduct,
  },
}
</script>

<style></style>
